import { commonActions } from '../app/actions';

export const setCurrentRoute = (id) => (dispatch) => {
  const { setValue } = commonActions('current_route');
  dispatch(setValue(id));
};

export const setMenuLinkClicked = (id) => (dispatch) => {
  const { setValue } = commonActions('menu_link_click');
  dispatch(setValue(id));
};
